import { getShadow, ownShadowStyle } from "@/utils/theme-helper";
import React from "react";
import { twMerge } from "tailwind-merge";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  shadow?: "none" | "little" | "lots";
  /** On a look-system website, where `shadow` may be own CSS. */
  lookSystem?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className,
  style,
  shadow,
  lookSystem,
}) => {
  const own = ownShadowStyle(shadow, lookSystem);
  return (
    <div
      className={twMerge(
        "bg-[var(--card-bg-color)] text-[var(--card-text-color)]",
        "homepage-card-rounded",
        getShadow(shadow, lookSystem),
        className,
      )}
      style={Object.keys(own).length ? { ...own, ...style } : style}
      data-component-type="Card"
    >
      {children}
    </div>
  );
};

export default Card;
